export enum PricingStrategy {
  CUSTOM = "CUSTOM",
  USER_SIMS = "USER_SIMS",
  EREBOR = "EREBOR",
}
